<div [ngClass]="{'bg-white border-bottom': userChecks}" class="mb-3">
  <div class="d-flex justify-content-between settings-item"
    [ngClass]="{'settings-item-dark': darkBgMode, 'darkBg': darkBg}">
    <div class="w-100 d-flex align-items-center">
      <i *ngIf="icon" class="fa {{icon}} mr-3"></i>
      <img *ngIf="imgSrc" style="max-width: 100%; height: 25px;" class="mr-3" src="{{imgSrc}}" alt="">
      <div class="d-flex align-items-center">
        <h3 *ngIf="userChecks" translate>{{title}}</h3>
        <p *ngIf="!userChecks" translate>{{title}}</p>
        <span *ngIf="isNewBadgeVisible()" class="small ml-3" style="color: #2c85cc; align-self: flex-start; font-weight: bold;">NEW
          *</span>
      </div>
    </div>
    <div class="choose-window">
      <ng-content select="[mySelect]"></ng-content>
    </div>
  </div>
</div>